let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("11NB9")).then(() => parcelRequire('dhF3T'));